var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container full-width"},[[_c('div',{staticClass:"text-subtitle1"},[_vm._v("Choose schedule")])]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }